
import Vue from 'vue'
import SocialLinks from '@/components/SocialLinks.vue'
import Newsletter from '@/components/Newsletter.vue'

export default Vue.extend({
  name: 'Footer',
  components: {
    SocialLinks,
    Newsletter,
  },
  props: {
    mainNavigation: {
      type: Array,
    },
  },
  data: () => ({
    informations: [
      {
        title: 'Terms and Conditions',
        to: '/terms-and-conditions',
      },
      {
        title: 'Privacy Policy',
        to: '/privacy-policy',
      },
    ],
  }),
})
